export const getCategories = () => [
	{ id: "Promos", label: "Promos" },
	{ id: "Paquetes", label: "Paquetes" },
	{ id: "Bebidas", label: "Bebidas" },
	{ id: "Botanas", label: "Botanas" },
	{ id: "Ensaladas y pastas", label: "Ensaladas y Pastas" },
	{ id: "Grill", label: "Grill" },
	{ id: "Pizzas", label: "Pizzas" },
	{ id: "Hamburguesas", label: "Hamburguesas" },
	{ id: "Postres", label: "Postres" },
	{ id: "HamburguesaRock", label: "HamburguesaRock" },
	{ id: "Mariscos", label: "Mariscos" },
];

const getDayOptions = () => [
	{ id: "mon", label: "Lunes" },
	{ id: "tue", label: "Martes" },
	{ id: "wed", label: "Miercoles" },
	{ id: "thu", label: "Jueves" },
	{ id: "fri", label: "Viernes" },
	{ id: "sat", label: "Sábado" },
	{ id: "sun", label: "Domingo" },
];

const options = [
	{
		label: "Nombre",
		type: "TextField",
		id: "name",
		required: true,
	},
	{
		label: "Descripcion",
		type: "TextField",
		id: "description",
		required: true,
	},
	{
		label: "Precio",
		type: "NumberFormat",
		isMoney: true,
		id: "price",
		required: true,
		parentSpecialRequirement: "hasMultipleOptions",
		specialRule: false,
	},
];

const getOptions = () => {
	return options;
};

const subCategories = [
	{
		label: "Banner",
		type: "File",
		id: "imgUrl",
	},
	{
		label: "Categoría obligatoria",
		type: "Checkbox",
		id: "required",
	},
	{
		label: "Nombre",
		type: "TextField",
		id: "name",
		required: true,
	},
	{
		label: "Descripcion",
		type: "TextField",
		id: "description",
		required: true,
	},
	{
		label: "Precio",
		type: "NumberFormat",
		isMoney: true,
		id: "price",
		required: true,
		specialRequirement: ["optionsAvailability", "hasMultipleOptions"],
		specialRule: [false, true],
	},
	{
		label: "Agregar opciones",
		type: "Checkbox",
		id: "optionsAvailability",
		tooltip: "Activar opciones",
	},
	{
		label: "Multiples opciones",
		type: "Checkbox",
		id: "hasMultipleOptions",
		tooltip: "Puede elegir opciones multiples",
		specialRequirement: "optionsAvailability",
	},
	{
		label: "Cantidad de opciones que puede elegir",
		type: "NumberFormat",
		id: "optionsAmount",
		specialRequirement: ["hasMultipleOptions", "optionsAvailability"],
	},
	{
		label: "Cantidad de veces que puede repetir una misma opción",
		type: "NumberFormat",
		id: "sameOptionMaxAmount",
		tooltip: "Debe ser menor o igual a la cantidad de opciones",
		specialRequirement: ["hasMultipleOptions", "optionsAvailability"],
		rule: "< optionsAmount",
	},
	{
		label: "Opciones",
		type: "Parent",
		id: "options",
		specialRequirement: "optionsAvailability",
		children: getOptions(),
	},
];

const getSubcategories = () => {
	return subCategories;
};
//Autocomplete <Autocomplete /> or Select for Options
const questions = [
	{
		label: "Banner",
		type: "File",
		id: "imgUrl",
	},
	{
		label: "Platillo activo",
		type: "Checkbox",
		id: "isAvailable",
	},
	{
		label: "Nombre",
		id: "name",
		type: "TextField",
		required: true,
	},
	{
		label: "Categoria",
		id: "category",
		type: "Select",
		options: [],
		required: true,
	},
	{
		label: "Descripcion",
		type: "TextField",
		id: "description",
		multiline: true,
		required: true,
	},
	{
		label: "Precio inicial",
		type: "NumberFormat",
		isMoney: true,
		id: "price",
		required: true,
	},
	{
		label: "Posicion en App",
		type: "NumberFormat",
		isMoney: false,
		id: "position",
		required: true,
	},
	{
		label: "Dias de servicio",
		type: "CheckboxMultiple",
		options: getDayOptions(),
		id: "availableDays",
	},
	{
		label: "Horario de servicio",
		type: "Checkbox",
		id: "isServiceScheduleRequired",
	},
	{
		label: "Hora inicial",
		type: "KeyboardTimePicker",
		id: "scheduleOpens",
		specialRequirement: "isServiceScheduleRequired",
		required: true,
	},
	{
		label: "Hora final",
		type: "KeyboardTimePicker",
		id: "scheduleCloses",
		specialRequirement: "isServiceScheduleRequired",
		required: true,
	},
	{ label: "Agregar subCategorias", type: "Checkbox", id: "subCategoriesAvailability" },
	{
		label: "subCategories",
		type: "Parent",
		id: "subCategories",
		specialRequirement: "subCategoriesAvailability",
		children: getSubcategories(),
	},
];

export { options, subCategories, questions };
